import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { logout, extendSession } from "./domain/auth/authActions";
import AppView, { getAccessibilityAttrs } from "./AppView";
import renderModals from "./renderModals";
import { FormattedMessage } from "react-intl";
import { selectLocale } from "./domain/i18n/i18nActions";
import track from "react-tracking";
import { recordEvent } from "api/session";
import isEmpty from "./utils/isEmpty";
class App extends Component {
    constructor(props, context) {
        super(props, context);
        this._timeoutHandler = null;
        this._$mainContainer = null;
        // private _$skipLinkLabel: HTMLElement | null = null;
        this._$skipLink = null;
        this._initialTitle = "";
        this._onClickSkip = this._onClickSkip.bind(this);
    }
    render() {
        return (<Fragment>
				<AppView {...this.props} skipLink={this._renderSkipLink()} modals={renderModals(this.props)}/>
			</Fragment>);
    }
    async componentDidMount() {
        /* Defines skip link and skip link label
        Used for accessibility */
        this._$skipLink = document.querySelector(".js-skipLink");
        // this._$skipLinkLabel = document.querySelector<HTMLElement>(".js-skipLink-label");
        this._$mainContainer = document.querySelector(".js-mainContainer");
        this._initialTitle = document.title;
        this._updateAfterPageChange();
    }
    componentDidUpdate() {
        this._updateAfterPageChange();
    }
    _onClickSkip() {
        this._$mainContainer.focus();
    }
    _updateAfterPageChange() {
        if (this.props.isActiveModal) {
            document.documentElement.classList.add("isActiveModal");
        }
        else {
            document.documentElement.classList.remove("isActiveModal");
        }
        /* Get the main page title from the markup */
        const pageHeaderElement = document.querySelector(".js-pageHeader");
        const pageHeader = (pageHeaderElement != null && pageHeaderElement.textContent) || "";
        document.title = isEmpty(pageHeader) ? this._initialTitle : `${this._initialTitle} - ${pageHeader}`;
        /* Add page label to skip link and focus on it.
        Setting focus to the top of the page when the "page loads" is for accessibility */
        // this._$skipLinkLabel!.textContent = pageHeader;
        clearTimeout(this._timeoutHandler);
        this._timeoutHandler = setTimeout(() => {
            /* Using timeout to correct iOS VO bug that tries to set focus on incorrect elements */
            this._$skipLink.focus();
        }, 250);
        /* Scroll to the top of the page */
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }
    _renderSkipLink() {
        const accessibilityAttrs = getAccessibilityAttrs(this.props);
        return (<button type="button" onClick={this._onClickSkip} className="linkSkip js-skipLink" {...accessibilityAttrs}>
				<FormattedMessage id="appContainer.skipLink" defaultMessage="Skip to content"/>
			</button>);
    }
}
export default track({}, {
    dispatch: data => recordEvent({
        action: "ClientEvent",
        data: JSON.stringify(data)
    })
})(connect((state) => {
    const { locale, messages } = state.i18n;
    const { isActiveModal } = state.ui;
    return {
        isActiveModal,
        isLoggedIn: state.auth.loggedIn,
        lastLogin: state.auth.lastLogin,
        locale,
        messages: messages[locale]
    };
}, {
    logout,
    onExtendSession: extendSession,
    selectLocale
})(App));



// WEBPACK FOOTER //
// ./src/assets/scripts/AppContainer.tsx